import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import "@fontsource-variable/schibsted-grotesk"; // wght axis; we use 400/500/600/650
import "@fontsource-variable/jetbrains-mono"; // wght axis; we use 400/500
import "./index.css";
import App from "./App.tsx";
import { installChunkRecovery } from "./utils/chunkRecovery";

// Recover once when an open tab outlives a deployment and references a lazy
// chunk whose fingerprint no longer exists. The helper guards against loops.
installChunkRecovery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </AuthProvider>
  </StrictMode>
);
